import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

const store = new Vuex.Store({
	// vuex中储存的数据全部存在这 获取方式 this.$store.state.参数名
	state: {
		show_solution:-1,//一级菜单下标
		language:localStorage.getItem('language') || 'CN',//语言
		scroll_height:0,//当前窗口滚动距离
		win_size:0,//当前窗口宽度
		headBarHeight:0,//头部栏高度
		// 用户信息
		user_info: localStorage.getItem('user_info') ? JSON.parse(localStorage.getItem('user_info')) : {},
		// 全局配置信息，全局混入了计算属性，可以直接使用
		config_info: localStorage.getItem('config_info') ? JSON.parse(localStorage.getItem('config_info')) : {},
		// 加载中信息
		login_text:'',
		// 点击菜单时传递的信息
		page_info:{},
		menu_list:[],//菜单数据
	},
	// 修改vuex中数据的方法放在这，提交方式 this.$store.commit('方法名',提交参数，对象、数组、字符串等，只能是一个参数)
	mutations: {
		// 是否显示
		setShowSolution(state,value){
			state.show_solution = value;
		},
		// 设置语言
		setLanguage(state,language){
			state.language = language;
			localStorage.setItem('language',language);
			location.reload();
		},
		// 窗口大小
		setWinSize(state,width){
			state.win_size = width;
		},
		// 滚动距离
		setScrollHeight(state,height){
			state.scroll_height = height;
		},
		// 头部栏高度
		setHeadBarHeight(state,height){
			state.headBarHeight = height
		},
		// 设置信息，this.$store.commit('setInfo',{type:'user_info',value:user_info})
		setInfo(state, obj) {
			let info = obj.value;
			if(typeof info == 'object'){
				let info = Object.assign({}, state[obj.type], obj.value);
				localStorage.setItem('user_info', JSON.stringify(info))
			}
			state[obj.type] = info;
		},
		// 退出登录，清除用户信息
		clearUserInfo(state) {
			state.user_info = {};
			localStorage.removeItem('user_info');
		},
	}
})

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js